import React from 'react';
import { Alert, Card, Col, Container, ListGroup, Row } from 'react-bootstrap';
import { FiBookOpen, FiHelpCircle, FiInfo, FiMail, FiTool } from 'react-icons/fi';

const SectionHeader = ({ icon, title, tone = 'primary' }) => (
  <div className="section-header-row">
    <div className={`icon-chip icon-chip-sm icon-chip-${tone}`}>{icon}</div>
    <h5 className="section-header-title">{title}</h5>
  </div>
);

const HelpSupportPage = () => {
  return (
    <Container fluid className="py-4">
      <div className="mb-4">
        <h1 className="page-title">Help &amp; Support</h1>
        <p className="page-subtitle mb-0">Guides, FAQs, and how to reach us.</p>
      </div>
      <Row className="g-3">
        <Col lg={8}>
          <Card className="border-0 shadow-sm card-accent-top mb-3">
            <Card.Body>
              <SectionHeader icon={<FiBookOpen />} title="User Guide" tone="primary" />
              <ListGroup variant="flush">
                <ListGroup.Item>Use the top department tabs to switch department context.</ListGroup.Item>
                <ListGroup.Item>Admin users can manage users, roles, departments, and permissions from Admin.</ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>

          <Card className="border-0 shadow-sm card-accent-top mb-3">
            <Card.Body>
              <SectionHeader icon={<FiTool />} title="How-To Steps" tone="info" />
              <ol className="mb-0 ps-3">
                <li>Select your department from the top bar.</li>
                <li>Use dashboard or analytics to review data.</li>
                <li>Contact support if data is missing or permission is denied.</li>
              </ol>
            </Card.Body>
          </Card>

          <Card className="border-0 shadow-sm card-accent-top">
            <Card.Body>
              <SectionHeader icon={<FiHelpCircle />} title="FAQ" tone="warning" />
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <strong>Why can&apos;t I see Analytics?</strong> Analytics is restricted to Admin users.
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Why is data missing in dashboard?</strong> Check selected department, project mapping, and upload status.
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Why can&apos;t I upload files?</strong> Upload is allowed for Admin/Editor roles only.
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Why does dashboard show placeholder?</strong> That department dashboard is not configured yet.
                </ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={4}>
          <Card className="border-0 shadow-sm card-accent-top mb-3">
            <Card.Body>
              <SectionHeader icon={<FiMail />} title="Support Contact" tone="success" />
              <Alert variant="info" className="mb-0">
                For help, contact{' '}
                <a href="mailto:piyush.pushkar@inveniatech.com">
                  piyush.pushkar@inveniatech.com
                </a>
                .
              </Alert>
            </Card.Body>
          </Card>

          <Card className="border-0 shadow-sm card-accent-top">
            <Card.Body>
              <SectionHeader icon={<FiInfo />} title="App Version" tone="secondary" />
              <p className="mb-1"><strong>Version:</strong>  v1.0.0</p>
              <p className="mb-0"><strong>Release Notes:</strong> Department-wise dashboards, analytics module (Admin-only), and Help &amp; Support page added.</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default HelpSupportPage;
